import * as Yup from "yup";

const addReviewInitialValues = {
  reviewName: "",
  reviewPoints: "",
  reviewDescription: "",
  reviewImage: "",
};
const addReviewValidationSchema = Yup.object().shape({
  reviewName: Yup.string().trim().required(" Name is required*"),
  reviewPoints: Yup.string().trim().required("Points is required*"),
  reviewDescription: Yup.string().trim().required("Description  is required*"),
  reviewImage: Yup.string().trim().required("Image is required*"),
});
const addReviewImgInitialValues = {
  reviewImage: "",
};
const addReviewImgValidationSchema = Yup.object().shape({
  reviewImage: Yup.string().trim().required("Image is required*"),
});
export {
  addReviewInitialValues,
  addReviewValidationSchema,
  addReviewImgInitialValues,
  addReviewImgValidationSchema,
};
